import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getInclusivenessDocs } from '../../../services/inclusivenessDocs/inclusivenessDocs';
import { showImageOrPdf } from '../../../utils/helpers/helpers';

export default function InclusiveStudentInfo({ applicant }) {
  const [t, i18n] = useTranslation();
  const [inclusivenessDocs, setInclusivenessDocs] = useState([]);

  useEffect(() => {
    if (applicant?.uuid) {
      getInclusivenessDocs({ application: applicant.uuid }).then((res) => {
        setInclusivenessDocs(res.results || []);
      });
    }

    return () => {};
  }, [applicant]);

  if (!applicant?.is_inclusive) {
    return (
      <div className='px-4 py-5 sm:px-6'>
        <p className='text-center text-gray-500'>
          Кандидат не относится к инклюзивным студентам
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className='px-4 py-5 sm:px-6'>
        <h3 className='text-lg font-medium leading-6 text-gray-900'>
          Информация об инклюзивности
        </h3>
        <p className='mt-1 max-w-2xl text-sm text-gray-500'>
          Данные об особых образовательных потребностях
        </p>
      </div>
      <div className='border-t border-gray-200'>
        <dl>
          <div className='bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Статус</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
              <span className='rounded-md bg-blue-100 px-2 py-1 text-blue-800'>
                Инклюзивный студент
              </span>
            </dd>
          </div>

          {applicant?.inclusive_comments && (
            <div className='bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Комментарии</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                {applicant.inclusive_comments}
              </dd>
            </div>
          )}

          {applicant?.inclusiveness && applicant.inclusiveness.length > 0 && (
            <div className='bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>
                Особенности здоровья
              </dt>
              <dd className='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                <ul className='list-disc pl-5'>
                  {applicant.inclusiveness.map((condition, index) => (
                    <li key={index}>
                      {condition === 'VISION' && t('signup.special_needs.vision')}
                      {condition === 'HEARING' && t('signup.special_needs.hearing')}
                      {condition === 'MOBILITY' && t('signup.special_needs.mobility')}
                      {!['VISION', 'HEARING', 'MOBILITY'].includes(condition) &&
                        condition}
                    </li>
                  ))}
                </ul>
              </dd>
            </div>
          )}

          {applicant?.inclusive_needs && applicant.inclusive_needs.length > 0 && (
            <div className='bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>
                Требования на экзамене
              </dt>
              <dd className='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                <ul className='list-disc pl-5'>
                  {applicant.inclusive_needs.map((need, index) => (
                    <li key={index}>
                      {need === 'ACCESSIBLE' &&
                        t('signup.special_needs.accessible_environment')}
                      {need === 'LARGE_FONT' &&
                        t('signup.special_needs.large_font')}
                      {need === 'BRAILLE' && t('signup.special_needs.braille')}
                      {!['ACCESSIBLE', 'LARGE_FONT', 'BRAILLE'].includes(need) &&
                        need}
                    </li>
                  ))}
                </ul>
              </dd>
            </div>
          )}

          {inclusivenessDocs && inclusivenessDocs.length > 0 && (
            <div className='bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>
                Подтверждающие документы
              </dt>
              <dd className='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                <div className='grid grid-cols-3 gap-2'>
                  {inclusivenessDocs.map((doc, index) => (
                    <div
                      key={doc?.uuid || index}
                      className='flex flex-col rounded-md border p-2'
                    >
                      {showImageOrPdf(doc?.document, 32)}
                      <a
                        href={doc?.document}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='mt-2 text-center text-sm font-medium text-blue-600 hover:text-blue-500'
                      >
                        Скачать
                      </a>
                    </div>
                  ))}
                </div>
              </dd>
            </div>
          )}
        </dl>
      </div>
    </div>
  );
}

